import {defineField, defineType} from 'sanity'
import {VscTag} from 'react-icons/vsc'
import {createUniqueFieldValidator} from '../../lib/validations'

export default defineType({
  name: 'blog.tag',
  title: 'Tag',
  type: 'document',
  icon: VscTag,
  groups: [{name: 'content', default: true}, {name: 'metadata'}],
  fields: [
    defineField({
      name: 'title',
      type: 'string',
      group: 'content',
      validation: (rule) =>
        rule
          .required()
          .custom(
            createUniqueFieldValidator('blog.tag', 'title', 'A tag with this title already exists'),
          ),
    }),
    defineField({
      name: 'metadata',
      type: 'metadata',
      group: 'metadata',
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
  },
})
